import { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { InfoImagePreview } from 'widgets/PresentationMode/ui/info/image/InfoImagePreview'
import { InfoVideoPreview } from 'widgets/PresentationMode/ui/info/video/InfoVideoPreview'
import { InfoAudioPreview } from 'widgets/PresentationMode/ui/info/audio/InfoAudioPreview'
import { InfoDocPreview } from 'widgets/PresentationMode/ui/info/doc/InfoDocPreview'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import styles from './styles.module.scss'

export const InfoPreview = observer(() => {
  const { organizationStore } = useEntitiesContext()
  const presentationStore = usePresentationModeContext()
  const { currentAttachment } = presentationStore
  const content = useMemo(() => {
    if (
      currentAttachment?.type === 'image' ||
      currentAttachment?.type === 'gif' ||
      currentAttachment?.type === 'previewGif' ||
      currentAttachment?.type === 'pdf'
    ) {
      return <InfoImagePreview withPagination={currentAttachment?.type === 'pdf'} />
    }
    if (currentAttachment?.type === 'video') {
      return <InfoVideoPreview />
    }
    if (currentAttachment?.type === 'audio') {
      return <InfoAudioPreview />
    }
    return <InfoDocPreview />
  }, [currentAttachment])

  useEffect(() => {
    if (
      organizationStore.isHipaaCompliant &&
      currentAttachment &&
      presentationStore.shouldTrackEvent
    ) {
      organizationStore.handleTrackOrganizationActivity({
        event: 'phi.file.viewed',
        data: {
          file_id: currentAttachment.id,
        },
      })
    }
  }, [currentAttachment])

  return <div className={styles.imageInfo}>{content}</div>
})
